<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">E-Saúde Diário</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/health-diaries/' + patient.id"
      no-data-label="Nenhum diário cadastrado"
      no-result-label="Nenhum diário encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <span @click="openModal(row)"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></span>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <span @click="openModal(row)"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></span>
        </div>
      </template>
    </data-table>
    <modal ref="modal" size="modal-lg" :modal-scrollable="true">
      <template #header>
          <div class="text-gray-777 font-roboto uppercase">
              <span>{{ $filters.formatDate(selectedItem.date) }} - {{ selectedItem.name }}</span>
          </div>
      </template>
      <template #body>
        {{ selectedItem.description }}
      </template>
      <template #footer>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModal">Fechar</button>
      </template>
    </modal>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal'
import DataTable from '@/Shared/DataTable'

export default {
  inject: ['patient'],
  components: {
    Modal,
    DataTable,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user);
    return {
      user,
    }
  },
  data() {
    return {
      selectedItem: Object,
      loadTable: true,
      columns: [
        {
          uniqid: 'health_diary_date',
          label: 'Data',
          field: 'date',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date),
        },
        {
          uniqid: 'health_diary_name',
          label: 'Atividade',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'health_diary_description',
          label: 'Descrição',
          field: 'description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModal(item) {
      this.selectedItem = item;
      this.$refs.modal.showModal = true;
    },
    closeModal() {
      this.$refs.modal.showModal = false;
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>